import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-task-edit-task-deadline',
    templateUrl: './task-edit-task-deadline.component.html',
    styleUrls: ['./task-edit-task-deadline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-edit-task-deadline' },
    standalone: false,
})
export class TaskEditTaskDeadlineComponent {
    @Input({ required: true }) taskDeadline: string;
    @Output() taskDeadlineChange = new EventEmitter<string>();
    @Input() isStandardFormField: boolean = false;

    protected minDeadline: Date;

    protected datePickerChange(): void {
        this.taskDeadlineChange.emit(this.taskDeadline);
    }

    protected onDatepickerOpened(): void {
        this.minDeadline = new Date();
        this.minDeadline.setHours(0, 0, 0);
    }

    protected onDatepickerClosed(): void {
        this.minDeadline = undefined;
    }
}
